
import * as React from 'react';
import { ListItem, StyledComponentProps, Divider, Grid, Typography } from '@material-ui/core';
import { contactMedicalExamination } from '../../../../model/contactsubscription';
import moment from 'moment';
import { isExpired, isNearExpiration } from './SubscriptionItem';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: reminder, done: boolean) => void;
    // onSubscriptionClick: (_id: string) => void;
    medicalExamination: contactMedicalExamination;
    onSelectItem: (item: any) => void;
    // isSelected: boolean;
    // showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}

export const MedicalItem = (props: IProps) => {

    const winOpen = (mex: contactMedicalExamination) => {
        window.open(mex.firebaseUri, mex.originalFileName, 'height=600,width=600');
    }

    const { medicalExamination: medical, classes, onSelectItem } = props;
    return (
        <>
            <ListItem key={medical._id}
                onClick={() => onSelectItem(medical)}
                className={isExpired(medical.expiresOn) ? classes.isExpired : (isNearExpiration(medical.expiresOn) ? classes.isNearExpiration : classes.isValid)}>
                <Grid container>
                    <Grid item xs={7} style={{ whiteSpace: 'pre' }}>
                        <Typography className={classes.typoPurchased}>
                            {"Visita Medica"}
                            {medical.notes && medical.notes !== "" ? `\n` + medical.notes : ""}
                        </Typography>
                    </Grid>
                    <Grid item xs={1}>
                        {medical.firebaseUri && <Typography className={classes.typoPurchased}>
                            {/* {medical.originalFileName}.{medical.extension} */}
                            <a className={classes.medicalFileContainer} style={{ cursor: 'pointer' }} onClick={(event) => { event.preventDefault(); winOpen(medical) }} href={medical.firebaseUri} target='_blank' rel='noopener noreferrer'>file</a>
                        </Typography>}
                    </Grid>
                    <Grid item xs={4}>
                        <Typography className={classes.typoPurchased}>
                            {'Valido dal: ' + moment(medical.validFrom).format('L')}</Typography>
                        <Typography className={classes.typoPurchased}>
                            {'Scade il: ' + moment(medical.expiresOn).format('L')}</Typography>
                    </Grid>
                </Grid>
            </ListItem>
            <Divider />
        </>
    );
}